import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';


@Injectable()
export class DisplaylabelService extends ServiceGlobal {

    name: string;
    sequence: any;
    code: string;

    name_alpha: any = 'name';
    api_find_all: any = 'labels';
    api_find_one: any = 'labels';
    api_delete: any = 'labels';
    loading: any = false;
    primary_key: any = 'label_id';
    tableName() { return 'indicator'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "label_id": "Label ID",
            "label_group": "Label Group",
            "type": "Type",
            "sequence": "Label Display Sequence",
            "name": "Display Label",
            "code": "Code",
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "label_id": {
                "type": "string"
            },
            "label_group": {
                "type": "string"
            },
            "type": {
                "type": "string",
                "required": {
                    "empty": true,
                }
            },
            "sequence": {
                "type": "int",
                "require": {
                    "empty": true,
                    "size": 20,
                },
            },

            "name": {
                "type": "string",
                "require": {
                    "empty": true,
                    "size": 200,
                },
            },

            "code": {
                "type": "string",
                "require": {
                    "empty": true,
                    "size": 6,
                },
            }
        });
    }

    save(id = false) {
        let link = API.GET_INDICATOR_LABELS;
        let attrs;
        let result;
        if (id) {
            attrs = this.getAttributesUpdate();
            link += '/' + attrs[this.primary_key];
            result = this._db.put(link, attrs);
        } else {
            attrs = this.getAttributes();
            result = this._db.post(link, attrs);
        }
        return result;
    }

    async findByLabelGroup(labelGroup) {
      let api = API.API_URL_COMMON + this.api_find_all + '?label_group=' + labelGroup;
      return this._db.get(api);
    }

    delete(id = true) {
        return this._db.delete(API.GET_INDICATOR_LABELS, id);
    }

}



// WEBPACK FOOTER //
// ./src/app/common/services/displaylabel.service.ts